// extracted by mini-css-extract-plugin
module.exports = {"sorting":"SortVehicles_sorting__23zcr","sorting_group":"SortVehicles_sorting_group__C-cxU","active":"SortVehicles_active__fFLal"};